// Celdas de Cargas - Productos con ID 900-999
const celdasCargas = [
  {
    id: 903,
    categoria: 'celdas-cargas',
    nombre: 'CELDAS CAMIONES',
    descripcion: 'En Servibalanzas suministramos e instalamos celdas de carga diseñadas para plataformas camioneras, con soluciones para operación estática y dinámica.',
    descripcion2: 'En Servibalanzas suministramos e instalamos celdas de carga diseñadas para plataformas camioneras, con soluciones para operación estática y dinámica. Disponemos de celdas tipo doble viga de 25 t y 30 t, celdas tipo bola grande  con excelente desempeño en básculas de camiones, y celdas KLPD para básculas dinámicas y proyectos con espacios reducidos. ',
    imagen: '/imagenes/productos/CeldasCargas/ccamiones1.webp',
    caracteristicas: [
      {
        titulo: 'Doble viga – 25 t y 30 t',
        items: [    
            'Geometría double shear beam para alta estabilidad y bajo error. ',
            'Excelente tolerancia a cargas laterales y desalineaciones típicas de plataformas largas. ',
            'Perfil bajo para reemplazo directo en básculas existentes. ',
            'Kits de montaje con topes mecánicos y sistemas antilevantamiento para mayor seguridad. ',
        ]
      },
      {
        titulo: 'KLPD – Dinámicas y espacios reducidos',
        items: [
            'Diseño compacto y de bajo perfil, ideal para retrofit donde el espacio es crítico. ',
            'Respuesta rápida y lineal para pesaje en movimiento (básculas dinámicas). ',
            'Opciones de montaje versátiles para integrarse a estructuras especiales. ',
        ]
      }
    ],
    opciones: [
      {
        id: 'doble-viga',
        nombre: 'DOBLE VIGA – 25 T Y 30 T',
        
      },
      {
        id: 'klpd',
        nombre: 'KLPD – DINÁMICAS Y ESPACIOS REDUCIDOS',
        
      }
    ],
    imagenes: [
      '/imagenes/productos/CeldasCargas/ccamiones1.webp',
      '/imagenes/productos/CeldasCargas/ccamiones2.webp',
      '/imagenes/productos/CeldasCargas/ccamiones3.webp',
      '/imagenes/productos/CeldasCargas/ccamiones4.webp',  
    ]
  },
  {
    id: 904,
    categoria: 'celdas-cargas',
    nombre: 'CELDAS DE CARGA SHEAR BEAMS',
    descripcion: 'Precisión y estabilidad para aplicaciones industriales exigentes.',
    descripcion2: ' Las celdas Shear Beam entregan alta exactitud y robustez en ambientes con vibración, golpes y desalineaciones. Su diseño de corte por cizalla mantiene la linealidad y reduce errores, ideal para plataformas y estructuras de proceso.',
    imagen: '/imagenes/productos/CeldasCargas/cshearbeams1.webp',
    caracteristicas: [
      {
        titulo: 'Características y beneficios',
        items: [
            'Construcción en acero aleado o inoxidable ',
            'Capacidades van desde los 500kg hasta los 10.000kg ',
            'Alta repetibilidad y baja deriva a largo plazo. ',
            'Excelente tolerancia a cargas laterales y puntuales (carros, pallets, impacto). ',
            'Perfil bajo para montajes compactos y retrofits. ',
            'Kits de montaje con antilevantamiento y topes mecánicos. ',
            'Compatibles con cajas sumadoras e indicadores industriales (salida mV/V ). ',
            'Certificaciones metrológicas disponibles (p. ej., OIML/NTEP, según modelo). ',
        ]
      },
      {
        titulo: 'Aplicaciones típicas ',
        items: [
            'Básculas de plataforma y tolvas. ',
            'Mesas de pesaje, dosificación y llenado. ',
            'Sistemas de control de proceso y formulación.',
        ]
      },
    ],
    opciones: [
      {
        id: 'celdas-shear-beams',
        nombre: 'CELDAS SHEAR BEAMS',
      }
    ],
    imagenes: [
      '/imagenes/productos/CeldasCargas/cshearbeams1.webp',
      '/imagenes/productos/CeldasCargas/cshearbeams2.webp',
      '/imagenes/productos/CeldasCargas/cshearbeams3.webp',

    ]
  },
  {
    id: 905,
    categoria: 'celdas-cargas',
    nombre: 'CELDAS PUNTO UNICO',
    descripcion: 'La opción ideal para plataformas compactas con una sola celda.',
    descripcion2: 'Las celdas Single-Point incorporan compensación de esquinas, por lo que mantienen la misma lectura aunque la carga se coloque fuera del centro. Son precisas, económicas y muy fáciles de integrar en balanzas de mesa, pesajes en línea y equipos de proceso. ',
    imagen: '/imagenes/productos/CeldasCargas/cpunto1.webp',
    caracteristicas: [
      {
        titulo: 'Características y beneficios',
        items: [
            'Compensación de esquina: una sola celda por plataforma, sin necesidad de caja sumadora. ',
            'Alta precisión y estabilidad para pesajes repetitivos y conteo de piezas. ',
            'Materiales: aluminio anodizado o acero inoxidable para ambientes agresivos y lavado. ',             
            'Amplio rango de capacidades (desde gramos hasta cientos de kilos) y tamaños de plataforma típicos de 200×200 hasta 800×800 mm (según modelo). ',
            'Certificaciones metrológicas disponibles (p. ej., OIML R60 C3/C4/C6, según modelo). ',
            'Montaje sencillo y altura baja: ideal para equipos compactos. ',
        ]
      },
      {
        titulo: 'Aplicaciones típicas ',
        items: [
            'Balanzas de mesa y de conteo. ',
            'Chequeadores de peso y transportadores con pesaje en línea. ',
            'Llenadoras y ensacadoras de baja/mediana capacidad. ',
            'Dosificación y control de procesos. ',
            'Equipos para retail, laboratorios   ',
        ]
      }
    ],
    opciones: [
      {
        id: 'celdas-punto-unico',
        nombre: 'CELDAS PUNTO UNICO',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/CeldasCargas/cpunto1.webp',
      '/imagenes/productos/CeldasCargas/cpunto2.webp',
      '/imagenes/productos/CeldasCargas/cpunto3.webp',
      '/imagenes/productos/CeldasCargas/cpunto4.webp',

    ]
  },
  {
    id: 906,
    categoria: 'celdas-cargas',
    nombre: 'CELDAS TIPO S',
    descripcion: 'Versátiles para tracción y compresión, precisas y fáciles de integrar.',
    descripcion2: 'Versátiles para tracción y compresión, precisas y fáciles de integrar. Las celdas tipo S destacan por su diseño simétrico que permite medir fuerza y peso en tracción o compresión con alta estabilidad. Son ideales para montajes suspendidos, dinamómetros y control de procesos donde se exige repetibilidad y montaje sencillo. ',
    imagen: '/imagenes/productos/CeldasCargas/cs1.webp',
    caracteristicas: [
      {
        titulo: 'Características y beneficios',
        items: [
            'Tracción y compresión en un solo cuerpo: una celda, dos modos de trabajo. ',
            'Alta precisión y repetibilidad para medición estable en procesos continuos. ',
            'Materiales: acero aleado niquelado o acero inoxidable para ambientes agresivos y lavado. ',
            'Roscas en ambos extremos (Métricas/UNC) para varillas, ojales o horquillas (clevis), facilitando el alineamiento axial. ',
            'Montaje simple con rótulas/uniball que minimizan cargas laterales y momentos. ',
            'Amplio rango de capacidades (desde pocos kilos hasta varias toneladas, según modelo). ',
        ]
      },
      {
        titulo: 'Aplicaciones típicas ',
        items: [
            'Balanzas de gancho y dinamómetros. ',
            'Tolvas y silos suspendidos; sistemas de dosificación por caída. ',
            'Máquinas de ensayo, prensas y control de fuerza. ',
            'Ensacado y llenado por peso en suspensión ',
        ]
      }
    ],
    opciones: [
      {
        id: 'celdas-tipo-s',
        nombre: 'CELDAS TIPO S',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/CeldasCargas/cs1.webp',
      '/imagenes/productos/CeldasCargas/cs2.webp',

    ]
  },
  {
    id: 907,
    categoria: 'celdas-cargas',
    nombre: 'CELDAS VISHAY 3510 (INOXIDABLE)',
    descripcion: 'Tedea 3510 es una celda de carga viga a corte de acero inoxidable con sellado hermético IP68, diseñada para plataformas de bajo perfil, transpaletas con pesaje y sistemas de pesaje en tanques y silos. ',
    descripcion2: 'Ofrece alta precisión, gran resistencia a ambientes agresivos y cable 6 hilos con sense para compensar automáticamente variaciones de resistencia del cable por temperatura o longitud. Cuenta con aprobaciones OIML R60 y NTEP y dispone de opciones para áreas peligrosas (EEx ia IIC T6 y FM)',
    imagen: '/imagenes/productos/CeldasCargas/cvishay1.webp',
    caracteristicas: [
      {
        titulo: 'Características',
        items: [
          '•	Construcción: acero inoxidable, herméticamente sellada IP68. ',
          '•	Exactitud / aprobación: OIML R60 C3/C6 y NTEP (según versión). ',
          '•	Perfil bajo con ranuras guía en caras de montaje para alineación sencilla. ',
          '•	Cableado: 6 hilos (incluye +Sense / −Sense) con cable poliuretano doble blindaje, 5 m. ',
          '•	Sobrecarga: 150 % de R.C. segura; 300 % última. ',
          '•	Opciones: aprobación EEx ia IIC T6 y FM para áreas clasificadas.',
          
        ]
      }
    ],
    opciones: [
      {
        id: 'celdas-vishay-3510-inoxidable',
        nombre: 'CELDAS VISHAY 3510 (INOXIDABLE)',
        
      },
    ],
    imagenes: [
      '/imagenes/productos/CeldasCargas/cvishay1.webp',
      '/imagenes/productos/CeldasCargas/cvishay2.webp',

    ]
  }
]; 

export default celdasCargas;
